import React from 'react'

import Confirmation from '@/components/Confirmation'
import { createRoot } from 'react-dom/client'

import { t } from './i18n'

// Store root references for reuse
const rootMap = new WeakMap()

const getRoot = container => {
  if (!rootMap.has(container)) {
    rootMap.set(container, createRoot(container))
  }
  return rootMap.get(container)
}

const showConfirmation = props => {
  const container = document.querySelector('.confirmation-container')
  if (!container) return
  const root = getRoot(container)
  root.render(<Confirmation {...props} />)
}

const unmountConfirmation = () => {
  const container = document.querySelector('.confirmation-container')
  if (!container) return
  const root = getRoot(container)
  root.render(null)
}

const getApiErrorMessage = response => {
  if (!response) return t('generic_error_message')

  const error = response.data.base || response.data[Object.keys(response.data)[0]]

  if (error) {
    return error[0].full_message
  } else {
    return t('generic_error_message')
  }
}

const showErrorModal = ({ title, errors, cancelAction = () => Turbo.visit(window.location) }) => {
  const text = (
    <div className='error-modal-container d-flex flex-column'>
      <div className='mb-4 font-weight-bold d-flex flex-row justify-content-center align-items-center title-container'>
        {title}
      </div>
      {errors && <div className='error-list text-start align-self-center d-flex flex-column'>{errors}</div>}
    </div>
  )

  showConfirmation({
    isOpen: true,
    closeOnConfirm: true,
    cancelText: t('close'),
    cancelAction,
    text
  })
}

// TODO: use this where appropriate
const showDefaultErrorModal = () =>
  showErrorModal({
    title: getApiErrorMessage(null)
  })

export { showConfirmation, unmountConfirmation, showErrorModal, showDefaultErrorModal, getApiErrorMessage }
